import content from './content.json';

// Nav y páginas: import estático → sin request, sin loading state
export const navConfig = content.nav;

export const getPageConfig = (path) =>
  content.pages[path] || content.pages['/'];

// Landing pages: fetch desde public/landings/{id}.json
// Para agregar una nueva landing, solo crear public/landings/mi-promo.json
// Cuando haya backend, reemplazar el fetch por: fetch(`/api/landings/${id}`)
export const getLandingPageConfig = async (id) => {
  const res = await fetch(`/landings/${id}.json`);
  if (!res.ok) throw new Error(`Landing "${id}" no encontrada`);
  return res.json();
};
